import store from '@ps/store'
import { hasPermission as permission } from '@com/permission'
import componentConstructor from '@com/permission/component-constructor'
import router from '@ps/router'

export const getPermissionKeys = (routerName: string): string[] => {
  if (routerName === 'workbench' || routerName === 'iv') {
    // console.log('当前页面权限', store.state.permission.workbench)
    return [
      ...store.state.permission.common,
      ...store.state.permission.workbench,
    ]
  }
  return [...store.state.permission.common]
}

/**
 * 权限判断
 * @param latchkey 权限 key 值
 * @param type 当第一个参数是数组的时候，type 可选 or 或 and，默认 and
 * @param keys 权限 key 列表
 */
export const hasPermission = (
  latchkey: string | string[],
  type?: 'and' | 'or',
  keys?: string[],
): boolean => {
  if (router.currentRoute.name) {
    return permission(
      latchkey,
      type || 'and',
      keys || getPermissionKeys(router.currentRoute.name),
    )
  }
  console.log('当前路由为空')
  return false
}

const PermissionManager = componentConstructor(hasPermission)

export default PermissionManager
